/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const SET_TOKEN = 'app/App/SET_TOKEN';
export const LOG_OUT = 'app/App/LOG_OUT';
export const LOAD_ACL = 'app/App/LOAD_ACL';
export const SET_ACL = 'app/App/SET_ACL';
export const SET_ERROR = 'app/App/SET_ERROR';
export const SET_NOTIFICATION = 'app/App/SET_NOTIFICATION';
